/**
 * Resolve the venue slug from the current hostname.
 *
 * Production hostnames look like: `espectaculos.<venue>.volteretarestaurante.com`
 *   → the second label is the venue slug.
 *
 * On localhost (dev), fall back to `?venue=<slug>` query param,
 * then to the `VITE_DEV_VENUE_SLUG` build-time env var,
 * then default to `manhattan` so the app still boots.
 */
export function resolveVenueSlug(): string {
  if (typeof window === 'undefined') return 'manhattan';

  const host = window.location.hostname;

  // Production: espectaculos.<venue>.volteretarestaurante.com
  const prodMatch = host.match(/^espectaculos\.([a-z0-9-]+)\.volteretarestaurante\.com$/i);
  if (prodMatch) return prodMatch[1].toLowerCase();

  // Dev / preview: query param wins
  const params = new URLSearchParams(window.location.search);
  const queryVenue = params.get('venue');
  if (queryVenue) return queryVenue.toLowerCase();

  // Build-time fallback
  if (import.meta.env.VITE_DEV_VENUE_SLUG) {
    return import.meta.env.VITE_DEV_VENUE_SLUG;
  }

  return 'manhattan';
}
